import * as STD     from '@emersya/mpa-std';
import EngineModule from '../EngineModule';
import { NS as PlannerFloorWallsNS } from '../components/viewer/planner/Floor-Walls/Floor-Walls';


export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'viewer-planner-floor-walls',
	dependencies :     [
		'oms-basket',
		'viewer-planner'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	modulesAfter :     [
		'viewer-planner-furniture-editor'
	],
	useFullWidth :     false,
	allowedCustomers : null,
	usableCondition :  null,
	displayCondition : null,
	generateComponentConfiguration() : PlannerFloorWallsNS.Configuration{
		if (!this.translations.backWall || !this.translations.wall || !this.translations.leftWall || !this.translations.rightWall || !this.translations.label || !this.translations.nameFloor || !this.translations.nameWall) {
			throw STD.errors.user('',{});
		}
		return {
			wall : this.translations.wall,
			backWall : this.translations.backWall,
			leftWall : this.translations.leftWall,
			rightWall : this.translations.rightWall,
			label : this.translations.label,
			nameFloor : this.translations.nameFloor,
			nameWall : this.translations.nameWall,
			allFree : this.configuration.allFree ? true : false,
			labelFloor : this.translations.labelFloor ? this.translations.labelFloor : null 
		};
	},
	async initialize() {
	}
});
